// import ModeSwitcher from "./ModeSwitcher";
import OutboundLinkIcon from "./OutboundLinkIcon";

function Announcement() {
  return (
    <div
      id="ab-full-width-with-dismiss-button-on-blue-bg"
      className="hidden md:block hs-removing:-translate-y-full bg-blue-600"
    >
      <div className="max-w-[85rem] px-4 py-2 sm:px-6 lg:px-8 mx-auto">
        <div className="flex items-center justify-center">
          <p className="text-white">
            マイナンバーカードの保険証利用登録がお済でない方は、早めのご登録を！{" "}
            <a
              className="decoration-2 underline font-medium hover:text-white/80"
              href="https://myna.go.jp/html/hokenshoriyou_top.html"
              target="myna.go.jp"
            >
              申し込み方法はこちら
            </a>
            <OutboundLinkIcon />
          </p>

          <div className="hidden ps-3 ms-auto">
            <button
              type="button"
              className="inline-flex rounded-lg p-1.5 text-white/80 hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-blue-600 focus:ring-white"
              data-hs-remove-element="#ab-full-width-with-dismiss-button-on-blue-bg"
            >
              <span className="sr-only">表示しない</span>
              <svg
                className="flex-shrink-0 size-4"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="4"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M18 6 6 18" />
                <path d="m6 6 12 12" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Announcement;
